"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Counter = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const Box_1 = require("./Box");
const color_1 = require("../constants/color");
const theme_1 = require("../constants/theme");
const utils_1 = require("../utils");
const COUNTER_STYLES = {
    'light-blue': { backgroundColor: color_1.Color.LIGHT_BLUE, color: color_1.Color.WHITE },
    'light-green': {
        backgroundColor: color_1.Color.LIGHT_GREEN,
        color: color_1.Color.DARK_GREEN,
    },
    'lighter-blue': { backgroundColor: color_1.Color.LIGHTER_BLUE, color: color_1.Color.BLUE },
    blue: { backgroundColor: color_1.Color.BLUE, color: color_1.Color.WHITE },
    green: { backgroundColor: color_1.Color.GREEN, color: color_1.Color.WHITE },
    purple: { backgroundColor: color_1.Color.PURPLE, color: color_1.Color.WHITE },
    red: { backgroundColor: color_1.Color.RED, color: color_1.Color.WHITE },
};
const FONT_STYLES = {
    large: { fontSize: theme_1.theme.font.size[4], size: 28 },
    medium: { fontSize: theme_1.theme.font.size[6], size: 20 },
    small: { fontSize: theme_1.theme.font.size[6.5], size: 16 },
};
exports.Counter = styled_1.default.div((props) => {
    const { backgroundColor, color } = COUNTER_STYLES[props.color ?? 'green'];
    const { fontSize, size } = FONT_STYLES[props.size ?? 'medium'];
    return {
        ...(0, Box_1.box)(props),
        alignItems: 'center',
        backgroundColor,
        borderRadius: 999,
        color,
        display: 'flex',
        flexShrink: 0,
        fontSize,
        fontWeight: theme_1.theme.font.weight.bold,
        height: size,
        justifyContent: 'center',
        lineHeight: `${size}px`,
        textAlign: 'center',
        userSelect: 'none',
        width: size,
        ...(0, utils_1.createStyles)(props.styles),
    };
});
